<template>
    <div>
        <div class="image-container">
            <router-link to="/"><b-img width="150" :src="require('../../assets/SIO_YouAreTheDJ_new.png')" fluid alt="Responsive image" /></router-link>
        </div>
        <h3 class="header">Sign In</h3>
        <p class="paragraph">Fill in the details below to create an account. If you have already created an account then <router-link class="a" to="/register" >tap here to register.</router-link></p>
        <b-form-group
                class="input"
                id="emailField"
                description="We'll never share your email with anyone else."
                label="Email address"
                label-for="email"
        >
            <b-form-input id="email" v-model="user.email" placeholder="Enter email" trim />
        </b-form-group>
        <b-form-group
                class="input"
                id="passwordField"
                label="Password"
                label-for="password"
        >
            <b-form-input id="password" v-model="user.password" placeholder="Enter password" type="password" trim />
        </b-form-group>
        <b-button :disabled="isLoading" @click="doLoginUser" size="lg" variant="default" class="sign-up-button">
            <b-spinner v-if="isLoading" />
            <span v-if="!isLoading">Sign me in</span></b-button>
        <p class="paragraph">Can't remember your password or just too lazy to type it? Give us your email below and we'll post a magic link.</p>
        <b-form-group
                class="input"
                id="emailFieldMagic"
                description="We'll never share your email with anyone else."
                label="Email address"
                label-for="emailMagic"
        >
            <b-form-input id="emailMagic" v-model="user.email" placeholder="Enter email" trim />
        </b-form-group>
        <b-button :disabled="isLoading" @click="doSendMagicLink" size="lg" variant="default" class="sign-up-button">
            <b-spinner v-if="isLoading" />
            <span v-if="!isLoading">Send magic link</span></b-button>
    </div>
</template>

<script>
    import LoginDto from '../../models/register-login/login';
    import { EventBus } from "../../EventBus";

    export default {
        name: "LoginForm",
        data() {
            return {
                user: new LoginDto(),
                isLoading: false
            }
        },
        methods: {
            doLoginUser() {
                if (this.user.email.length > 0 && this.user.password.length > 0) {
                    this.isLoading = true;
                    this.$axios({
                        method: 'GET',
                        url:'login',
                        auth: {
                            username: this.user.email,
                            password: this.user.password
                        }
                    }).then(result => {
                        localStorage.setItem('token', result.data.token);
                        EventBus.$emit('message', {message: `Sign in successful, let's get you started`, type:'success'});
                        this.$store.dispatch('setAuthStatus', true).then(() => {
                            return this.$store.dispatch('setUser', result.data.user);
                        });
                    }).then(() => {
                        this.isLoading = false;
                        // Redirect to Landing page
                        if (this.user.email === 'admin') {
                            return this.$store.dispatch('setIsAdmin', true);
                        } else {
                            return this.$store.dispatch('setIsAdmin', false);
                        }
                    }).then(() => {
                        if (this.user.email === 'admin') {
                            this.$router.push('/admin');
                        } else {
                            this.$router.push('/landing');
                        }
                    }).catch(() => {
                        this.isLoading = false;
                        EventBus.$emit('message', {message: 'Oops this isn’t working, don’t worry please show your host to resolve it', type: 'danger'});
                    });
                }
            },
            doSendMagicLink() {
                if (this.user.email.length > 0) {
                    this.isLoading = true;
                    this.$axios.post('login/link', {email: this.user.email}).then(() => {
                        this.isLoading = false;
                        EventBus.$emit('message', {message: `Thanks, we are sending you an email now with your magic link`, type:'success'});
                    }).catch(() => {
                        this.isLoading = false;
                        EventBus.$emit('message', {message: 'Oops this isn’t working, don’t worry please show your host to resolve it', type: 'danger'});
                    });
                }
            }
        },
        mounted() {
            // Check if magic link is sent
            if (this.$route.fullPath.indexOf('uuid') > -1) {
                EventBus.$emit('loading-show');
                this.$axios({
                    method: 'GET',
                    url:'login/link',
                    auth: {
                        username: this.$route.query['email'],
                        password: this.$route.query['uuid']
                    }
                }).then(result => {
                    localStorage.setItem('token', result.data.token);
                    EventBus.$emit('message', {message: `Sign in successful, let's get you started`, type:'success'});
                    this.$store.dispatch('setAuthStatus', true).then(() => {
                        return this.$store.dispatch('setUser', result.data.user);
                    });
                }).then(() => {
                    EventBus.$emit('loading-hide');
                    // Redirect to Landing page
                    this.$router.push('/landing');
                }).catch(err => {
                    this.isLoading = false;
                    EventBus.$emit('message', {message: err.message, type: 'danger'});
                    EventBus.$emit('loading-hide');
                });
            }
        }
    }
</script>

<style scoped>
    .header {
        margin-left: 10px;
        margin-top: 20px;
    }
    .paragraph {
        margin-left: 10px;
        margin-top: 20px;
    }

    .a {
        color: rgba(235, 63, 36,100) !important;
        text-decoration: none;
    }

    .input {
        margin-left: 10px;
        margin-right: 10px;
    }

    .sign-up-button {
        width: 95%;
        text-align: center;
        margin-left: 10px;
        margin-right: 10px;
    }
</style>
